export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"property":"theme-color","content":"#ffffff"},{"property":"start_url","content":"/?utm_source=pwa"}],"link":[{"rel":"preconnect","href":"https://pilulkacz.vshcdn.net"},{"rel":"preconnect","href":"https://pilulkacz.vshcdn.net","crossorigin":"crossorigin"},{"rel":"dns-prefetch","href":"https://pilulkacz.vshcdn.net"},{"rel":"preconnect","href":"https://use.typekit.net","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://use.typekit.net"},{"rel":"preconnect","href":"https://www.googletagmanager.com"},{"rel":"dns-prefetch","href":"https://www.googletagmanager.com"},{"rel":"dns-prefetch","href":"https://translate.googleapis.com"},{"rel":"dns-prefetch","href":"https://c.seznam.cz"},{"rel":"dns-prefetch","href":"https://sdp-api.lnd.bz"},{"rel":"dns-prefetch","href":"https://cdn.onesignal.com"},{"rel":"dns-prefetch","href":"https://ad.doubleclick.net"},{"rel":"dns-prefetch","href":"https://a.clarity.ms"}],"style":[],"script":[{"key":"cookiebar-hide","innerHTML":"try{if(localStorage.getItem('pilulkaCookieSettings')){var s=document.createElement('style');s.id='cookiebar-hide';s.textContent='.cookiebar{display:none!important}';document.head.appendChild(s)}}catch(e){}"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000